module.exports = __webpack_public_path__ + "static/media/OS.b677ea84.png";